var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4166 11.0833C13.4166 11.3928 13.2937 11.6895 13.0749 11.9083C12.8561 12.1271 12.5593 12.25 12.2499 12.25H1.74992C1.4405 12.25 1.14375 12.1271 0.924961 11.9083C0.706168 11.6895 0.583252 11.3928 0.583252 11.0833V4.66667C0.583252 4.35725 0.706168 4.0605 0.924961 3.84171C1.14375 3.62292 1.4405 3.5 1.74992 3.5H4.08325L5.24992 1.75H8.74992L9.91659 3.5H12.2499C12.5593 3.5 12.8561 3.62292 13.0749 3.84171C13.2937 4.0605 13.4166 4.35725 13.4166 4.66667V11.0833Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00008 9.91667C8.28874 9.91667 9.33341 8.872 9.33341 7.58333C9.33341 6.29467 8.28874 5.25 7.00008 5.25C5.71142 5.25 4.66675 6.29467 4.66675 7.58333C4.66675 8.872 5.71142 9.91667 7.00008 9.91667Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.ce8f7d837b09bbb1b3a3cb53e3faf07b.svg";
export { ForwardRef as ReactComponent };